import { employeeStore } from "./store";
import type {
  EmployeeState,
  EmployeeStore,
  UserIdentifier
} from "./store.types";

/** Selector to get the whole state - the whole employee */
const storeSelector = (state: EmployeeStore): EmployeeState => state;

export function getEmployee(): EmployeeStore {
  return storeSelector(employeeStore.getState());
}

export function getUserIdentifier(): UserIdentifier | null {
  const { employeeChildId, employeeCardHex, groupName } = storeSelector(
    employeeStore.getState()
  );

  if (employeeChildId) {
    return { type: "child-id", value: employeeChildId };
  }
  if (employeeCardHex) {
    return { type: "child-card-hex", value: employeeCardHex };
  }
  if (groupName) {
    return { type: "group-name", value: groupName };
  }

  return null;
}
